import {WidgetType} from 'common/constants/survey';

import {RadioQuestionCardSize} from './RadioQuestion.types';

export const getCardSize = (view: WidgetType, count: number): RadioQuestionCardSize => {
    switch (view) {
        case WidgetType.OneRow: {
            if (count === 2) {
                return 'l';
            }
            if (count === 3) {
                return 'm';
            }
            return 's';
        }
        case WidgetType.Radio:
        default:
            return 'xl';
    }
};
